import React from "react";
import ContentModerationList from "@/components/contentModeration/ContentModerationList";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Communities: list with search, status / date filters and View / Deactivate / Reactivate / Delete.
 */
const CommunitiesModerationList = () => (
  <ContentModerationList sectionKey="communities" />
);

CommunitiesModerationList.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.communities.list,
    pathname: contentModeration.communities.list,
    active: true,
  },
];

export default CommunitiesModerationList;
